import { useCallback } from 'react';
import { useCartStore } from '../store/cartStore';

export const useCart = () => {
  const {
    items,
    addItem,
    removeItem,
    updateQuantity,
    clearCart,
    getTotalItems,
    getTotalPrice,
  } = useCartStore();

  const addToCart = useCallback((product, quantity = 1) => {
    for (let i = 0; i < quantity; i++) {
      addItem(product);
    }
  }, [addItem]);

  const removeFromCart = useCallback((productId) => {
    removeItem(productId);
  }, [removeItem]);

  const changeQuantity = useCallback((productId, quantity) => {
    updateQuantity(productId, quantity);
  }, [updateQuantity]);

  const isInCart = useCallback((productId) => {
    return items.some(item => item.id === productId);
  }, [items]);

  const getItemQuantity = useCallback((productId) => {
    const item = items.find(item => item.id === productId);
    return item?.quantity || 0;
  }, [items]);

  return {
    items,
    totalItems: getTotalItems(),
    totalPrice: getTotalPrice(),
    addToCart,
    removeFromCart,
    changeQuantity,
    clearCart,
    isInCart,
    getItemQuantity,
  };
};